export default Object.freeze({
  MoreMenuSections: {
    imageWidth: 90,
    imageHeight: 90,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  MoreMenuAppsAndGames: {
    imageWidth: 180,
    imageHeight: 180,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  MashupInsider: {
    imageWidth: 1280,
    imageHeight: 720,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  MashupMoreFrom: {
    imageWidth: 90,
    imageHeight: 90,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  BannersTvEPG: {
    imageWidth: 960,
    imageHeight: 150,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  BannersTabletPortrait: {
    imageWidth: 1456,
    imageHeight: 180,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
  BannersTabletLandScape: {
    imageWidth: 1940,
    imageHeight: 180,
    extensions: "png",
    accept: "image/png",
    enforceStrictImageDimensions: true,
  },
})